(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fv-brands"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fv-brand-directory')) {
  customElements.define('fv-brand-directory', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const input = this.querySelector('input[type="search"]');
      const cards = Array.from(this.querySelectorAll('[data-brand]'));
      const count = this.querySelector('[data-count-template]');
      const empty = this.querySelector('.fv-brands-empty');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      const filter = () => {
        const query = normalize(input.value);
        let visible = 0;
        cards.forEach(card => {
          card.hidden = !normalize(card.dataset.brand).includes(query);
          if (!card.hidden) visible += 1;
        });
        count.textContent = count.dataset.countTemplate.replace('__COUNT__', visible);
        empty.hidden = visible > 0;
      };
      input.addEventListener('input', filter);
      filter();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fv-cart-recommendations')) {
    customElements.define('fv-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
      }
      disconnectedCallback() {
        this.unsubscribe?.();
        this.controller?.abort();
      }
      async refresh() {
        this.controller?.abort();
        const controller = new AbortController();
        this.controller = controller;
        this.hidden = true;
        const url = new URL(this.dataset.url, window.location.origin);
        url.searchParams.set('section_id', this.dataset.section);
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const replacement = html.querySelector('fv-cart-recommendations');
          if (replacement && this.isConnected) this.replaceWith(replacement);
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-discovery-edit"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fv-discovery-edit')) {
  customElements.define('fv-discovery-edit', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const filters = this.querySelector('.fv-edit-filters');
      filters.hidden = false;
      const apply = button => {
        const terms = button.dataset.notes.split(',').filter(Boolean);
        let shown = 0;
        this.querySelectorAll('[data-sample-notes]').forEach(card => {
          const matches = !terms.length || terms.some(term => card.dataset.sampleNotes.includes(term));
          card.hidden = !matches || shown >= 8;
          if (!card.hidden) shown += 1;
        });
        filters.querySelectorAll('button').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        this.querySelector('.fv-edit-empty').hidden = shown > 0;
      };
      filters.querySelectorAll('button').forEach(button => button.addEventListener('click', () => apply(button)));
      apply(filters.querySelector('button'));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-matchmaker"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  const opener=event.target.closest('[data-fv-consultation-open]');
  if(opener){const dialog=document.querySelector('.fv-consultation-dialog');if(!dialog)return;const frame=dialog.querySelector('iframe');if(!frame.src)frame.src=frame.dataset.src;dialog.showModal();}
  if(event.target.closest('[data-fv-consultation-close]'))event.target.closest('dialog').close();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fv-review-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fv-review-slideshow')) {
    customElements.define('fv-review-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = [...this.querySelectorAll('[data-review-slide]')];
        this.index = 0;
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.playing = this.dataset.autoplay === 'true' && !this.motion.matches;
        this.stage = this.querySelector('[data-review-stage]');
        this.status = this.querySelector('[data-review-status]');
        this.toggle = this.querySelector('[data-review-toggle]');
        if (this.slides.length < 2 || !this.toggle) return;
        this.querySelector('[data-review-controls]').hidden = false;
        this.querySelector('[data-review-previous]').addEventListener('click', () => this.move(-1), options);
        this.querySelector('[data-review-next]').addEventListener('click', () => this.move(1), options);
        this.toggle.addEventListener('click', () => {
          this.playing = !this.playing;
          this.render();
        }, options);
        this.motion.addEventListener('change', event => {
          if (event.matches) {
            this.playing = false;
            this.render();
          }
        }, options);
        this.render();
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!this.playing || document.hidden || this.matches(':hover') || this.contains(document.activeElement)) return;
          this.index = (this.index + 1) % this.slides.length;
          this.render();
        }, 6500);
      }
      move(direction) {
        this.playing = false;
        this.index = (this.index + direction + this.slides.length) % this.slides.length;
        this.render();
      }
      render() {
        this.stage.setAttribute('aria-live', this.playing ? 'off' : 'polite');
        this.slides.forEach((slide, index) => { slide.hidden = index !== this.index; });
        this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
        this.toggle.textContent = this.playing ? this.toggle.dataset.pause : this.toggle.dataset.play;
        this.toggle.setAttribute('aria-pressed', String(!this.playing));
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
